// extracted by mini-css-extract-plugin
export var container = "PlatformSwitcher-module--container--5653d";
export var externalLink = "PlatformSwitcher-module--external-link--a31d4";
export var icon = "PlatformSwitcher-module--icon--f3d63";
export var platform = "PlatformSwitcher-module--platform--f9334";
export var platformIntro = "PlatformSwitcher-module--platform-intro--bc085";
export var platformName = "PlatformSwitcher-module--platform-name--44022";
export var toggle = "PlatformSwitcher-module--toggle--62b8a";